import { BuilderUI, getComponent, getUIComponent, RenderBuildNode } from "@builder/store/slices/BuilderSlice/builderMap";
import { InstalledBuilderElement } from "@builder/store/slices/builderElementsInstalledApiSlice";
import { BuildComponentKey, NodeSizes } from "@common/build/types";

export type UIComponentsByCategory = {
    [key: string]: BuilderUI[];
};

export const extendUIWithCustomIframes = (
    uiComponents: UIComponentsByCategory,
    builderElementsForInstalledExtensions?: InstalledBuilderElement[]
): UIComponentsByCategory => {
    if (builderElementsForInstalledExtensions && builderElementsForInstalledExtensions.length > 0) {
        const iframeTemplate = getUIComponent("iframe");

        const dynamicElements: BuilderUI[] = builderElementsForInstalledExtensions.map(dynamicElement => {
            return {
                ...iframeTemplate,
                group: "Custom Elements",
                dynamicElement
            };
        });

        return {
            ...uiComponents,
            "Custom Elements": dynamicElements
        };
    }

    return uiComponents;
};

export const getElementToAdd = (key: BuildComponentKey, dynamicElement?: InstalledBuilderElement) => {
    const elemToAdd = getComponent(key);
    const elemWithDynamicElement = {
        ...elemToAdd,
        ...(dynamicElement
            ? {
                  customName: dynamicElement?.name,
                  type: "component",
                  nodeSize: {
                      width: dynamicElement?.width ? NodeSizes.CUSTOM : NodeSizes.FILL,
                      height: dynamicElement?.height ? NodeSizes.CUSTOM : NodeSizes.FILL
                  },
                  attr: {
                      style:
                          dynamicElement?.width || dynamicElement?.height
                              ? { width: dynamicElement?.width || "100%", height: dynamicElement?.height || "100%" }
                              : { flexGrow: 1, height: "0" }
                  },
                  iframeUrl: dynamicElement?.iframeUrl,
                  isOffline: dynamicElement?.isOffline,
                  noEdit: true
              }
            : {})
    } as RenderBuildNode;
    return elemWithDynamicElement;
};
